import gql from 'graphql-tag';

export const getCampusTablets = gql`
  query getCampusTablets {
    resources {
      campus {
        campusStudent
        campus {
          id
          name
          libraries {
            id
            name
          }
        }
      }
    }
  }
`;

export const getDatesTablet = gql`
  query getDatesTablet($idLibrary: Float!) {
    resources {
      datesTablet(idLibrary: $idLibrary) {
        date
        hourStart
        hourEnd
        hours
      }
    }
  }
`;

export const getDatesComputer = gql`
  query getDatesComputer($idLibrary: Float!) {
    resources {
      datesComputer(idLibrary: $idLibrary) {
        date
        hourStart
        hourEnd
        hours
      }
    }
  }
`;

export const subscribeResourceTablet = gql`
  mutation subscribeResourceTablet(
    $hours: Float!
    $hourStart: Float!
    $idLibrary: Float!
  ) {
    subscribeResourceTablet(
      hours: $hours
      hourStart: $hourStart
      idLibrary: $idLibrary
    ) {
      idReservation
      typeError
      messageError
    }
  }
`;

export const subscribeResourceComputer = gql`
  mutation subscribeResourceComputer(
    $hours: Float!
    $hourStart: Float!
    $idLibrary: Float!
  ) {
    subscribeResourceComputer(
      hours: $hours
      hourStart: $hourStart
      idLibrary: $idLibrary
    ) {
      idReservation
      typeError
      messageError
    }
  }
`;

export const getTabletDetail = gql`
  query getReservationDetail($id: String!) {
    resources {
      reservationDetail(id: $id) {
        id
        type
        date
        hourStart
        hourEnd
        ubication
        campus
        flat
        address
        canBeOverridden
        toleranceTime
      }
    }
  }
`;

export const cancelReservation = gql`
  mutation cancelSubscriptionResource($id: String!) {
    cancelSubscriptionResourceTablet(id: $id) {
      cancelled
      typeError
      messageError
    }
  }
`;

export const getSubscribedsTablets = gql`
  query getSubscribedsTablets {
    resources {
      subscribeds {
        id
        type
        date
        hourStart
        hourEnd
        ubication
      }
    }
  }
`;

export const getStatusResource = gql`
  query getStatusResource {
    resources {
      status {
        type
        status
        message
      }
      penalties {
        type
        penaltie
      }
    }
  }
`;
